module.exports = __webpack_public_path__ + "img/NukedTV-Web_01.7fb7aa59.png";